import React from "react";

interface NotificationBadgeProps {
  count: number;
  variant?: "error" | "warning" | "info" | "neutral" | "refresh" | "override";
  className?: string;
}

export const NotificationBadge: React.FC<NotificationBadgeProps> = ({
  count,
  variant = "neutral",
  className = "",
}) => {
  if (count <= 0) return null;

  return (
    <span
      className={`absolute -top-2 -right-2 text-xs rounded-full w-5 h-5 flex items-center justify-center bg-crane-blue-gray text-crane-white ${className}`}
    >
      {count}
    </span>
  );
};
